import axios from './axiosConfig';

const api = {
    // 添加简历
    insertResume: (areaId, postId, candidateName, englishName, age, birthday, gender, country, nation, politicalOutlook, idCardNumber,
        idCardCategory, residentialAddress, permanentAddress, phone, email, highestEducation, graduationTime, arrivalTime, relationshipFlag, selfReportRepeatFlag,
        agreePostAdjustFlag, agreeAreaAdjustFlag, salaryExpectation, recruitmentChannel, recruitmentChannelOther, recommenderWorkNo, recommenderName, recommenderPhone, file,
        widelyFlag) => axios.post('/resume/insertResume',
        {
            'area.areaId': areaId,
            'post.postId': postId,
            candidateName: candidateName,
            englishName: englishName,
            age: age,
            birthday: birthday,
            gender: gender,
            country: country,
            nation: nation,
            politicalOutlook: politicalOutlook,
            idCardNumber: idCardNumber,
            idCardCategory: idCardCategory,
            residentialAddress: residentialAddress,
            permanentAddress: permanentAddress,
            phone: phone,
            email: email,
            highestEducation: highestEducation,
            graduationTime: graduationTime,
            arrivalTime: arrivalTime,
            relationshipFlag: relationshipFlag,
            selfReportRepeatFlag: selfReportRepeatFlag,
            agreePostAdjustFlag: agreePostAdjustFlag,
            agreeAreaAdjustFlag: agreeAreaAdjustFlag,
            salaryExpectation: salaryExpectation,
            recruitmentChannel: recruitmentChannel,
            recruitmentChannelOther: recruitmentChannelOther,
            recommenderWorkNo: recommenderWorkNo,
            recommenderName: recommenderName,
            recommenderPhone: recommenderPhone,
            file: file,
            widelyFlag: widelyFlag
        }),
    // 广投简历
    insertExtensiveResume: (areaId, postId, candidateName, englishName, age, birthday, gender, country, nation, politicalOutlook, idCardNumber,
        idCardCategory, residentialAddress, permanentAddress, phone, email, highestEducation, graduationTime, arrivalTime, relationshipFlag, selfReportRepeatFlag,
        agreePostAdjustFlag, agreeAreaAdjustFlag, salaryExpectation, recruitmentChannel, recruitmentChannelOther, recommenderWorkNo, recommenderName, recommenderPhone, file,
        widelyFlag, widelyCompanyIdList) => axios.post('/resume/insertExtensiveResume',
        {
            'area.areaId': areaId,
            'post.postId': postId,
            candidateName: candidateName,
            englishName: englishName,
            age: age,
            birthday: birthday,
            gender: gender,
            country: country,
            nation: nation,
            politicalOutlook: politicalOutlook,
            idCardNumber: idCardNumber,
            idCardCategory: idCardCategory,
            residentialAddress: residentialAddress,
            permanentAddress: permanentAddress,
            phone: phone,
            email: email,
            highestEducation: highestEducation,
            graduationTime: graduationTime,
            arrivalTime: arrivalTime,
            relationshipFlag: relationshipFlag,
            selfReportRepeatFlag: selfReportRepeatFlag,
            agreePostAdjustFlag: agreePostAdjustFlag,
            agreeAreaAdjustFlag: agreeAreaAdjustFlag,
            salaryExpectation: salaryExpectation,
            recruitmentChannel: recruitmentChannel,
            recruitmentChannelOther: recruitmentChannelOther,
            recommenderWorkNo: recommenderWorkNo,
            recommenderName: recommenderName,
            recommenderPhone: recommenderPhone,
            file: file,
            widelyFlag: widelyFlag,
            widelyCompanyIdList: widelyCompanyIdList
        })
};
export default api;
